import { combineReducers } from 'redux';
import landingPagesList from './LandingPages/reducer';
import createLandingPage from './CreateLandingPage/reducer';
import editLandingPage from './EditLandingPage/reducer';
import form from './LandingPageForm/reducer';

const initialState = {
  loading: false,
  error: '',
};

const mainReducer = (state = initialState, {
  type,
}) => {
  switch (type) {
    default:
      return state;
  }
};

const landingsReducer = combineReducers({
  main: mainReducer,
  list: landingPagesList,
  create: createLandingPage,
  edit: editLandingPage,
  form,
});

export default landingsReducer;
